import React from 'react'
import { fnum } from '../../utils/utils'
import PRSEditPostForm from './PRSEditPostForm'
import PRSAddCostForm from './PRSAddCostForm'
import moment from 'moment'

export default class PRSPostItem extends React.Component {

  state = {
    edit: false,
    add: false
  }

  handleEditClick = e => {
    e.preventDefault();
    this.setState({edit: true});
  }

  handleAddClick = (e) => {
    e.preventDefault();
    this.setState({add: true});
  }

  cancelEdit = () => {
    this.setState({edit: false});
  }

  cancelAdd = () => {
    this.setState({add: false});
  }

  render() {

    const {
      data,
      costs,
      allPmnts,
      num,
      updtBlnc,
      editPost,
      addSets,
      srvcs,
      srvgs,
      ctypes,
      comps,
      tab
    } = this.props;
    let costSum = 0;
    let pmntSum = 0;
    let payedSum = 0;
    let earliest = moment().add(1, 'years').format('Y-MM-DD');
    for (let id = 0; id < costs.length; id++) {
      costSum += costs[id].post_price * costs[id].post_qntt;
      const pmnts = allPmnts[costs[id].post_id];
      for (let i = 0; i < pmnts.length; i++) {
        const pmnt = pmnts[i];
        pmntSum += pmnt.post_price * pmnt.post_qntt;
        if (pmnt.post_payed) {
          payedSum += pmnt.post_price * pmnt.post_qntt;
        }
        else if (earliest > pmnt.post_bdate) {
          earliest = pmnt.post_bdate;
        }
      }
    }
    const { edit, add } = this.state;
    const pColor = pmntSum === payedSum ? 'green' :
      (earliest <= moment().format('Y-MM-DD') ? 'red' : '');
    if (edit){
      return (
        <PRSEditPostForm
          data={data}
          cancelEdit={this.cancelEdit}
          updtBlnc={updtBlnc}
          editPost={editPost}
          srvcs={srvcs}
          srvgs={srvgs}
        />
      );
    }
    else{
      return (
        <tr style={{backgroundColor: "#f5f5f5"}} onClick={this.handleEditClick}>
          <td>{num}</td>
          <td className="hover-popup-container">
            {data.post_desc}
            <div onClick={e => e.stopPropagation()}>
              <div
                className="hover-popup"
              >
                <button
                  className="btn btn-info"
                  onClick={this.handleAddClick}
                >
                  Добавить подряд
                </button>
              </div>
              {add && (
                <PRSAddCostForm
                  data={{
                    post_srvc_id: data.post_srvc_id,
                    post_desc: data.post_desc,
                    post_order_id: data.post_order_id,
                    post_price: 0,
                    post_qntt: 1,
                    post_note: "",
                    post_active: 1,
                    post_seller: 117,
                    post_payer: data.post_seller,
                    post_bdate: data.post_bdate,
                    post_avans: 1,
                    post_payed: 0,
                    post_srvg_id: data.post_srvg_id,
                    post_link: data.post_id
                  }}
                  cancelAdd={this.cancelAdd}
                  updtBlnc={updtBlnc}
                  editPost={editPost}
                  addSets={addSets}
                  srvgs={srvgs}
                  ctypes={ctypes}
                  comps={comps}
                />
              )}
            </div>
          </td>
          <td className="text-right">{fnum(data.post_price)}</td>
          <td className="text-right">{fnum(data.post_qntt)}</td>
          <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
          <td className="text-right info">{fnum(costSum)}</td>
          <td className="text-right text-success">
            {fnum(data.post_price*data.post_qntt-costSum)}
          </td>
          <td>
            {tab === 'prs' && (
              <span style={{color:pColor}}>
                {pmntSum !== payedSum && `Оплатить ${moment(earliest).format('L')}`}
              </span>
            )}
            {pmntSum !== costSum && (
              <div style={{color: 'red'}}>
                Долг {fnum(costSum - pmntSum)}
              </div>
            )}
            {data.post_note && <div>{data.post_note}</div>}
          </td>
        </tr>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSPostItem.js